import api from '../config/Api';

const endpoint = 'v1/attribute-cost-parametrization';

export default {

  getAttributeCostParams( attributeId, params ) {
    return api.get( `${endpoint}/${attributeId}`, params );
  },

  updateAttributeCostParam( id, data ) {
    return api.put( `${endpoint}/${id}`, data );
  },
};
